module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('a', {
      staticClass: "main-link",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.accounts.show',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n          " + _vm._s(item.from_name)), _c('br'), _vm._v("\n        <" + _vm._s(item.from_address) + ">\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Host: "), _c('strong', [_vm._v(_vm._s(item.host))]), _c('br'), _vm._v("\n          Port: "), _c('strong', [_vm._v(_vm._s(item.port))]), _c('br'), _vm._v("\n          Nazwa użytkownika: "), _c('strong', [_vm._v(_vm._s(item.username))])])]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "mode_edit",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: 'admin.accounts.edit',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "highlight_off",
        "color": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(item)
        }
      }
    }, [_vm._v("Usuń")])], 1)])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("\n        Nazwa\n      ")]), _vm._v(" "), _c('th', [_vm._v("\n        Dane konta\n      ")]), _vm._v(" "), _c('th', [_vm._v("\n        Akcje\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3a35bca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/List.vue
// module id = 282
// module chunks = 0